import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Container } from 'components/layout/Container';
import CheckoutBilling from '../../components/checkout/billing/CheckoutBilling';
import 'styles/_form.scss';

const Checkout = ({ history }) => (
  <>
    <Helmet title='Checkout - 360ra' />
    <Container>
      <div className='checkout'>
        <div className='checkout-content'>
          <CheckoutBilling history={history} />
        </div>
      </div>
    </Container>
  </>
);

Checkout.propTypes = {
  history: PropTypes.object,
};

export default Checkout;
